import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
} from '@mui/material';
import { capitalize } from 'lodash';
import ReferralDocuments from '../referral/documentUploads/ReferralDocuments';

export default function PatientReferralDocuments({
  isSameOrg = false,
  parsedData,
  referralUuid,
  onDisableSendReferral = null,
}) {
  return (
    <Card>
      <CardHeader
        title={parsedData.clinic.provider_name + (parsedData.specialty ? ' - ' : '') + capitalize(parsedData.specialty.name)}
        subheader={parsedData.clinic.name + ' - ' + parsedData.clinic.address}
      />
      <CardContent>
        <ReferralDocuments
          referralUuid={referralUuid}
          isSameOrg={isSameOrg}
          onDisableSendReferral={onDisableSendReferral} 
        />

      </CardContent>
    </Card>
  );
}
